import type { ReactNode } from 'react'

export type ContextualMenuPreviewState =
  | 'default'
  | 'hover'
  | 'open'
  | 'expanded'

export type ContextualMenuItem = {
  id: string
  label: string
  icon?: ReactNode
  disabled?: boolean
  onSelect?: () => void
  /** Nested submenu items. */
  items?: ContextualMenuItem[]
}

export const CONTEXTUAL_MENU_PREVIEW_STATES: ContextualMenuPreviewState[] = [
  'default',
  'hover',
  'open',
  'expanded',
]

export const CONTEXTUAL_MENU_PREVIEW_STATE_LABELS: Record<
  ContextualMenuPreviewState,
  string
> = {
  default: 'Default',
  hover: 'On hover',
  open: 'On click',
  expanded: 'Expanded',
}

export type ContextualMenuProps = {
  items: ContextualMenuItem[]
  ariaLabel?: string
  open?: boolean
  defaultOpen?: boolean
  onOpenChange?: (open: boolean) => void
  className?: string
  /** Dark surface styling. */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: ContextualMenuPreviewState
}
